import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=f25c4208&scoped=true&"
import script from "./UploadExcel.vue?vue&type=script&lang=js&"
export * from "./UploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=f25c4208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25c4208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
